export const EyeIcon = ({ stroke = "#15112D", size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.666992 8.00002C0.666992 8.00002 3.33366 2.66669 8.00033 2.66669C12.667 2.66669 15.3337 8.00002 15.3337 8.00002"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.666992 8C0.666992 8 3.33366 13.3333 8.00033 13.3333C12.667 13.3333 15.3337 8 15.3337 8"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
